import React from 'react'
import './Settings.css'
const Settings = () => {
  return (
    <div className='FadeIn' id='Settings'>
      <span>Action de Gestionnaire Dashboard</span>
      <div>
        <span>Creer un compte</span>
      </div>
      <div>
        <span>Supprimer un compte</span>
      </div>
      <div>
        <span>Modifier le mot de passe d'un compte</span>
      </div>
      <div>
        <span>Modifier le mail d'un compte</span>
      </div>
      <div>
        <span>Hierarchiser un compte</span>
      </div>

    </div>
  )
}

export default Settings